import { Component, OnInit } from '@angular/core';
import { merge, Observable, of } from 'rxjs';
import { formatDate, Location } from '@angular/common';
import { AuthService } from 'src/app/share/services/auth.service';
import { IMyOptions, ToastService } from 'ng-uikit-pro-standard';
import { delay, map, switchMap } from 'rxjs/operators';
import { CommonService } from 'src/app/share/services/common.service';
import { IAdjustmentData, IPayrollDayActivity, IPayrollDayData, IPayrollDayDetail, IPayrollDisplay, IPayrollPeriod, IStatementData, ITimesheetDetail, PayrollService } from './payroll.service';
import { ExcelService } from 'src/app/share/excel-docs/excel.service';
import { FormInputComponent, IFormInputViewModel } from 'src/app/share/forms/form-input/form-input.component';
import { FormOkCancelComponent, IFormOkCancelViewModel } from 'src/app/share/forms/form-ok-cancel/form-ok-cancel.component';

import * as moment from 'moment';
import { FormSelectComponent, IFormSelectChangedArg, IFormSelectViewModel } from 'src/app/share/forms/form-select/form-select.component';
import { DateUtil } from 'src/app/share/utils/date-util';
import { IActionModel } from 'src/app/share/entities/data-view';
import { IPayrollCompareCardViewModel, IPayrollComparison } from './payroll-compare-card/payroll-compare-card.component';
import { IDriverBreakDay } from './payroll-break/payroll-break.component';

@Component({
  selector: 'app-payroll',
  templateUrl: './payroll.component.html',
  styleUrls: ['./payroll.component.scss']
})
export class PayrollComponent implements OnInit {

  private readonly apiPath: string = '/api/accounting';

  constructor(private authService: AuthService, private location: Location, private commonService: CommonService, private payrollService: PayrollService,
    private excelService: ExcelService, private toastrService: ToastService) { }

  vm$: Observable<IPayrollPageViewModel>;
  vmi: IPayrollPageInfoViewModel;
  vmv$: Observable<IPayrollViewModel>;
  vmd$: Observable<IDriverPayrollViewModel>;
  showPayrollViewModel: boolean = false;
  showDriverPayrollViewModel: boolean = false;
  currentPayrollPeriod: number = 0;
  statementsNotCreated: boolean = false;
  statementsNotEmailed: boolean = false;
  statementsWithErrors: boolean = false;
  statementsEmailedWithError: boolean = false;
  chauffeursWithWarnings: boolean = false;
  showPayrollInAuditMode: boolean = false;
  chauffeursWithNotSignedTimesheet: boolean = false;
  timeSheetsWithIssue: boolean = false;
  chauffeursReviewNotCompleted: boolean = false;


  searchData: string = '';

  tmDatePickerOptions: IMyOptions = {
    todayBtnTxt: "Today",
    clearBtnTxt: "Clear",
    closeBtnTxt: "Close",
    showTodayBtn: true,
    showClearDateBtn: true,
    dateFormat: 'mm/dd/yyyy'
  };

  locationOptionsSelect: Array<any> = [
    { value: 'NYC', label: 'Secaucus' },
    { value: 'LAX', label: 'Los Angeles' },
    { value: 'CHI', label: 'Chicago' }
  ]

  ngOnInit(): void {
    this.vmi = this.setPageInfoViewModel();

    this.vm$ = this.loadPage$();
  }

  refreshPage() {
    this.vmi = this.setPageInfoViewModel();
    this.vm$ = this.loadPage$();
    this.authService.userInRole;
  }

  cancel() {
    this.location.back();
  }

  goBack() {
    this.location.back();
  }

  getSelectedValue(id: number, data: any) {

    this.resetPageInfoViewModel();

    var ret = data?.rows?.find(d => d.payrollPeriodId == id);

    this.vmi.currentPayrollPeriod.payrollPeriodDriverId = 0;
    this.vmi.showTimeSheetCheckbox = ret && ret.payrollLocation == 'LAX' ? true : false;
    this.vmi.includeTimeSheetPage = false;//ret && ret.payrollLocation == 'LAX' ? true : false;
    this.vmi.sortByDriverName = ret && ret.payrollLocation == 'LAX' ? true : false;
    this.vmi.currentPayrollPeriod = ret ? ret : {};
    this.currentPayrollPeriod = this.vmi.currentPayrollPeriod.payrollPeriodId;
    this.chauffeursWithWarnings = false;
    this.chauffeursWithNotSignedTimesheet = false;
    this.chauffeursReviewNotCompleted = false;

    this.vmi.currentPayrollPeriod.payrollCheckDate = moment(this.vmi.currentPayrollPeriod.endDate, "YYYY-MM-DD").add(6, 'days').format('YYYY-MM-DD');

    if (this.vmi?.currentPayrollPeriod?.queueStatus != 2) {
      const notReadyMesssage = `The payroll ${formatDate(this.vmi.currentPayrollPeriod.startDate, 'MM-dd-yyyy', 'en-US')} - 
              ${formatDate(this.vmi.currentPayrollPeriod.endDate, 'MM-dd-yyyy', 'en-US')}  ${this.vmi.currentPayrollPeriod.payrollLocation} not ready`;
      this.vmi.messageString = notReadyMesssage;
    } else if (!this.vmi?.currentPayrollPeriod?.payrollPeriodLocked && this.vmi?.currentPayrollPeriod?.runCalculationSuggestion) {
      this.vmi.messageString = 'You MUST re-calculate before you start working on payroll! ';
    }

    this.displayPayrollData();
  }

  isReadyToRunPayroll(data: IPayrollPeriod): boolean {
    if ((this.vmi?.messageString ?? '').length > 0 && !this.vmi?.currentPayrollPeriod.runCalculationSuggestion)
      return false;
    if (this.vmi?.currentPayrollPeriod?.payrollPeriodId <= 0)
      return false;
    if (this.vmi?.currentPayrollPeriod?.queueStatus != 2)
      return false;

    return true;
  }

  setPageInfoViewModel(): IPayrollPageInfoViewModel {
    const ret: IPayrollPageInfoViewModel = {
      payrollDate: undefined,
      recalculatePayroll: false,
      lockPayrollPeriod: false,
      includeTimeSheetPage: false,
      sortByDriverName: false,
      currentPayrollPeriod: {
        payrollPeriodId: 0,
        startDate: undefined,
        endDate: undefined,
        payrollLocation: '',
        payrollPeriodLocked: true,
        payrollCheckDate: undefined,
        adjustmentsCommited: true,
        lockedByUserName: undefined,
        lockedDateTime: undefined,
        totalDriversInPeriod: undefined,
        statementCreated: undefined,
        statementErrors: undefined,
        statementEmailed: undefined,
        statementEmailErrors: undefined,
        payrollPeriodDriverId: undefined,
        versionNumber: 0,
        includeReportingInCalculation: false,
        isEmailStatementActive: false,
        runCalculationSuggestion: false,
        includePrepTimeInCalculation: false
      },
      messageString: undefined,
      showTimeSheetCheckbox: false,
      confirmationType: 0,
      adjustmentsCommited: true,
      reservationFormVm: undefined,
      dayFormVm: undefined,
      lockFormVm: undefined,
      emailFormVm: undefined,
      calcFormVm: undefined,
      progressFormVm: undefined,
      showDriverEmailButton: false,
      statementAvailable: false,
      driverEmails: undefined,
      actionErrorMessage: undefined,
      actionMessage: undefined,
      warningCount: 0,
      notSignedTimeSheetsCount: 0,
      timeSheetsIssueCount: 0,
      isReviewCompleted: false,
      isReviewNotCompletedCount: 0
    }
    if (this.vmv$) {
      this.vmv$ = undefined;
    }
    return ret;
  }

  resetPageInfoViewModel() {
    this.vmi.payrollDate = undefined;
    this.vmi.recalculatePayroll = false;
    this.vmi.lockPayrollPeriod = false;
    this.vmi.includeTimeSheetPage = false;
    this.vmi.sortByDriverName = false;
    this.vmi.showTimeSheetCheckbox = false;
    this.vmi.confirmationType = 0;
    this.vmi.adjustmentsCommited = true;
    this.vmi.reservationFormVm = undefined;
    this.vmi.dayFormVm = undefined;
    this.vmi.totalFormVm = undefined;
    this.vmi.lockFormVm = undefined;
    this.vmi.emailFormVm = undefined;
    this.vmi.calcFormVm = undefined;
    this.vmi.messageString = undefined;
    this.vmi.progressFormVm = undefined;
    this.vmi.showDriverEmailButton = false;
    this.vmi.statementAvailable = false;
    this.vmi.driverEmails = undefined;
    this.vmi.actionErrorMessage = undefined;
    this.vmi.actionMessage = undefined;
    this.vmi.warningCount = 0;
    this.vmi.notSignedTimeSheetsCount = 0;
    this.vmi.timeSheetsIssueCount = 0;
    this.vmi.isReviewCompleted = false;
    this.vmi.isReviewNotCompletedCount = 0;

    this.statementsNotCreated = false;
    this.statementsNotEmailed = false;
    this.statementsWithErrors = false;
    this.statementsEmailedWithError = false;
  }

  /**
   * 
   * @returns 
   */
  async createPDFFile() {
    if (this.vmi.currentPayrollPeriod.payrollPeriodId == 0)
      return;

    this.showActionMessage('Start processing the request');

    try {
      // show status start

      // todo... is this needed anymore?  just going to create statements and save them, I don't think we need this.

      // invoke async action
      const result = await of({}).pipe(
        delay(100),
        switchMap(() => this.getPayrollData$(this.vmi.currentPayrollPeriod.payrollPeriodId, this.vmi.sortByDriverName))
      ).toPromise();

      // do work
      if (result.payrollDataVm != undefined) {
        var fromDate = formatDate(this.vmi.currentPayrollPeriod.startDate, 'MM-dd-yyyy', 'en-US');
        var toDate = formatDate(this.vmi.currentPayrollPeriod.endDate, 'MM-dd-yyyy', 'en-US');
        var fileName = `EmpireCLS-${this.vmi.currentPayrollPeriod.payrollLocation}-PayStatement-${fromDate}-${toDate}.pdf`;

        this.vmi.currentPayrollPeriod.payrollCheckDate = moment(this.vmi.currentPayrollPeriod.payrollCheckDate).format('YYYY-MM-DD');

        const blob = this.payrollService.generatePdfFile(result.payrollDataVm, fileName, this.vmi.includeTimeSheetPage, this.vmi.currentPayrollPeriod ?? {});
      }

      // show state end

    } catch (err) {

    }
  }

  async createOnePDFFile() {
    if (this.vmi.currentPayrollPeriod.payrollPeriodId == 0 || this.vmi.currentPayrollPeriod.payrollPeriodDriverId == 0)
      return;

    this.showActionMessage('Start processing the request');

    if (this.vmi.statementAvailable) {
      const payrollDataItems = await of({}).pipe(
        delay(100),
        switchMap(() => this.payrollBlobRequestImpl(this.vmi.currentPayrollPeriod.payrollPeriodId, this.vmi.currentPayrollPeriod.payrollPeriodDriverId)),
        map(ctx => ctx.statementDataVm ?? undefined)
      ).toPromise();

      if (payrollDataItems) {
        const blob = await new Response(payrollDataItems.statement).blob();

        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = (payrollDataItems.fileName ?? '').length > 0 ? payrollDataItems.fileName : "Statement.pdf";
        link.click();
      }

      return;
    }
    const payrollDataItems = await of({}).pipe(
      delay(100),
      switchMap(() => this.getPayrollData$(this.vmi.currentPayrollPeriod.payrollPeriodId, this.vmi.sortByDriverName, false, false, this.vmi.currentPayrollPeriod.payrollPeriodDriverId)),
      map(ctx => ctx.payrollDataVm ?? [])
    ).toPromise();

    if (payrollDataItems.length > 0) {
      var fromDate = formatDate(this.vmi.currentPayrollPeriod.startDate, 'MM-dd-yyyy', 'en-US');
      var toDate = formatDate(this.vmi.currentPayrollPeriod.endDate, 'MM-dd-yyyy', 'en-US');
      var fileName = `EmpireCLS-${this.vmi.currentPayrollPeriod.payrollLocation}-PayStatement-${fromDate}-${toDate}.pdf`;

      this.vmi.currentPayrollPeriod.payrollCheckDate = moment(this.vmi.currentPayrollPeriod.payrollCheckDate).format('YYYY-MM-DD');

      const blob = this.payrollService.generatePdfFile([payrollDataItems[0]], fileName, this.vmi.includeTimeSheetPage, this.vmi.currentPayrollPeriod ?? {}, false, false);
    }
  }

  /**
   * 
   * @returns 
   */
  async createExcelFile() {
    if (this.vmi.currentPayrollPeriod.payrollPeriodId == 0)
      return;

    try {
      const documentType = 'xlsx';  // xlsx or csv

      // show status start


      // invoke async action
      const result = await of({}).pipe(
        delay(100),
        switchMap(() => this.getPayrollData$(this.vmi.currentPayrollPeriod.payrollPeriodId, this.vmi.sortByDriverName))
      ).toPromise();

      // do work
      if (result.payrollDataVm != undefined) {
        var fromDate = formatDate(this.vmi.currentPayrollPeriod.startDate, 'MM-dd-yyyy', 'en-US');
        var toDate = formatDate(this.vmi.currentPayrollPeriod.endDate, 'MM-dd-yyyy', 'en-US');
        var fileName = `EmpireCLS-${this.vmi.currentPayrollPeriod.payrollLocation}-PayStatement-${fromDate}-${toDate}.${documentType}`;
        var printData = this.vmi.currentPayrollPeriod.payrollLocation == 'LAX'
          ? this.payrollService.preparePeriodTotalForExcelLAX(result.payrollDataVm, fileName, this.vmi.currentPayrollPeriod.versionNumber, this.vmi.currentPayrollPeriod.payrollLocation)
          : this.payrollService.preparePeriodTotalForExcel(result.payrollDataVm, fileName);
        this.excelService.generateExcelFromPrintData(printData, documentType).then(a => (a.message ?? '').length > 0 ? this.vmi.messageString = a.message : a.message = '');
      }

      // show state end

    } catch (err) {

    }
  }

  /**
   * 
   * @param index 
   * @returns 
   */
  setPopoverPlacement(index: number): string {
    return index > 0 ? 'top' : 'buttom';
  }


  /**
   * 
   * @param payrollPeriodId 
   * @returns 
   */
  private getPayrollData$(payrollPeriodId: number, sortByDriverName: boolean, onlyWithMissingStatement: boolean = false,
    onlyNotEmalledStatements: boolean = false, payrollPeriodDriverId: number = 0): Observable<IPayrollPageViewModel> {
    return this.payrollRequestImpl(payrollPeriodId, 'get-payroll-data', false, '', sortByDriverName, onlyWithMissingStatement, onlyNotEmalledStatements, payrollPeriodDriverId);
  }

  /**
   * 
   * @param action 
   * @param paramData 
   * @returns 
   */
  private submitCommandInvoke(action: string, paramData: any): Observable<IDriverPayrollViewModel> {
    return this.commonService.getData('PageCommand', 'payroll', action, paramData/*, this.apiPath*/);
  }

  /**
   * 
   * @returns 
   */
  private loadPage$(): Observable<IPayrollPageViewModel> {
    return this.payrollRequestImpl(0, 'page-load', false);
  }

  /**
   * 
   * @param payrollPeriodId 
   * @param action 
   * @returns 
   */
  private payrollRequestImpl(payrollPeriodId: number, action: string, showStatus: boolean, emailAddressToNotify: string = '', sortByDriverName: boolean = false,
    onlyWithMissingStatement: boolean = false, onlyNotEmalledStatements: boolean = false, payrollPeriodDriverId: number = 0): Observable<IPayrollPageViewModel> {
    return this.commonService.getData('PageCommand', 'payroll', action, {
      payrollPeriodId: payrollPeriodId,
      emailAddressToNotify: emailAddressToNotify,
      sortByDriverName: sortByDriverName,
      onlyWithMissingStatement: onlyWithMissingStatement,
      onlyNotEmalledStatements: onlyNotEmalledStatements,
      payrollPeriodDriverId: payrollPeriodDriverId
    }/*, this.apiPath*/).pipe(
      map((v: IPayrollPageViewModel) => {
        if (v.workingText)
          return { ...v };

        const ret = { ...v, actionsAllowed: true };
        if (ret.data) {
          ret.payrollDataVm = ret.data.payrollData ? ret.data.payrollData : null;
          ret.payrollPeriodsVm = ret.data.payrollPeriods ? ret.data.payrollPeriods : null;
        }
        return ret;
      })
    );
  }

  /**
   * 
   * @param payrollPeriodId 
   * @param action 
   * @returns 
   */
  private payrollBlobRequestImpl(payrollPeriodId: number, payrollPeriodDriverId: number = 0): Observable<IPayrollPageViewModel> {
    return this.commonService.getData('PageCommand', 'payroll', 'get-statement-blob', { payrollPeriodId: payrollPeriodId, payrollPeriodDriverId: payrollPeriodDriverId }/*, this.apiPath*/).pipe(
      map((v: IPayrollPageViewModel) => {
        if (v.workingText)
          return { ...v };

        const ret = { ...v, actionsAllowed: true };
        if (ret.data) {
          ret.statementDataVm = ret.data.statementData ? ret.data.statementData : undefined;
        }
        return ret;
      })
    );
  }

  // Payroll view
  /**
   * 
   */
  async displayPayrollData() {
    this.showPayrollViewModel = true;
    this.vmi.currentPayrollPeriod.payrollPeriodDriverId = 0;
    this.vmv$ = this.getPayrollViewData$(this.vmi.currentPayrollPeriod.payrollPeriodId, this.vmi.sortByDriverName);
  }

  showDriverPayroll(vm: IPayrollDisplay) {
    this.showPayrollViewModel = false;
    this.showDriverPayrollViewModel = true;
    this.vmi.currentPayrollPeriod.payrollPeriodDriverId = vm.payrollPeriodDriverId;
    this.vmi.showDriverEmailButton = false;
    this.vmi.statementAvailable = false;
    this.vmi.driverEmails = undefined;
    this.showPayrollInAuditMode = false;
    this.vmd$ = this.getDriverPayrollForDisplay$(vm.payrollPeriodId, vm.payrollPeriodDriverId);
  }

  doDataSearch(vm: IPayrollViewModel, searchVal: string) {
    this.statementsNotCreated = false;
    this.statementsNotEmailed = false;
    this.statementsWithErrors = false;
    this.statementsEmailedWithError = false;
    this.chauffeursWithWarnings = false;
    this.chauffeursWithNotSignedTimesheet = false;
    this.timeSheetsWithIssue = false;
    this.chauffeursReviewNotCompleted = false;

    if (searchVal.length === 0) {
      vm.payrollDisplayDataFilteredVm = vm.payrollDisplayDataVm;
      return;
    }

    vm.payrollDisplayDataFilteredVm = [];
    vm.payrollDisplayDataVm.forEach(r => {
      if (r.driverCode.toLowerCase().indexOf(searchVal.toLowerCase()) > -1
        || r.driverName.toLowerCase().indexOf(searchVal.toLowerCase()) > -1
        || r.editUsers.toLowerCase().indexOf(searchVal.toLowerCase()) > -1
        || (r.confirmations && r.confirmations.length && r.confirmations.indexOf(searchVal) > -1)) {
        vm.payrollDisplayDataFilteredVm.push(r);
      }
    });
  }

  statementsNotEmailedChanged(vm: IPayrollViewModel, event: any) {
    this.statementsNotCreated = false;
    this.statementsWithErrors = false;
    this.statementsEmailedWithError = false;
    this.chauffeursWithWarnings = false;
    this.chauffeursWithNotSignedTimesheet = false;
    this.chauffeursReviewNotCompleted = false;
    this.timeSheetsWithIssue = false;
    if (event.checked == false) {
      vm.payrollDisplayDataFilteredVm = vm.payrollDisplayDataVm;
      return;
    }

    vm.payrollDisplayDataFilteredVm = [];
    vm.payrollDisplayDataVm.forEach(r => {
      if (!r.statementEmailStatus || r.statementEmailStatus == 0) {
        vm.payrollDisplayDataFilteredVm.push(r);
      }
    });
  }

  statementsEmailedErrorChanged(vm: IPayrollViewModel, event: any) {
    this.statementsNotCreated = false;
    this.statementsNotEmailed = false;
    this.statementsWithErrors = false;
    this.chauffeursWithWarnings = false;
    this.chauffeursWithNotSignedTimesheet = false;
    this.timeSheetsWithIssue = false;
    this.chauffeursReviewNotCompleted = false;
    if (event.checked == false) {
      vm.payrollDisplayDataFilteredVm = vm.payrollDisplayDataVm;
      return;
    }

    vm.payrollDisplayDataFilteredVm = [];
    vm.payrollDisplayDataVm.forEach(r => {
      if (r.statementEmailStatus == 3) {
        vm.payrollDisplayDataFilteredVm.push(r);
      }
    });
  }

  statementsNotCreatedChanged(vm: IPayrollViewModel, event: any) {
    this.statementsNotEmailed = false;
    this.statementsWithErrors = false;
    this.statementsEmailedWithError = false;
    this.chauffeursWithWarnings = false;
    this.chauffeursWithNotSignedTimesheet = false;
    this.timeSheetsWithIssue = false;
    this.chauffeursReviewNotCompleted = false;
    if (event.checked == false) {
      vm.payrollDisplayDataFilteredVm = vm.payrollDisplayDataVm;
      return;
    }

    vm.payrollDisplayDataFilteredVm = [];
    vm.payrollDisplayDataVm.forEach(r => {
      if (!r.statementStatus || r.statementStatus == 0) {
        vm.payrollDisplayDataFilteredVm.push(r);
      }
    });
  }

  statementsCreatedErrorChanged(vm: IPayrollViewModel, event: any) {
    this.statementsNotCreated = false;
    this.statementsNotEmailed = false;
    this.statementsEmailedWithError = false;
    this.chauffeursWithWarnings = false;
    this.chauffeursWithNotSignedTimesheet = false;
    this.chauffeursReviewNotCompleted = false;
    this.timeSheetsWithIssue = false;
    if (event.checked == false) {
      vm.payrollDisplayDataFilteredVm = vm.payrollDisplayDataVm;
      return;
    }

    vm.payrollDisplayDataFilteredVm = [];
    vm.payrollDisplayDataVm.forEach(r => {
      if (r.statementStatus == 3) {
        vm.payrollDisplayDataFilteredVm.push(r);
      }
    });
  }

  filterChauffeursWithWarnings(vm: IPayrollViewModel, event: any) {
    this.statementsNotCreated = false;
    this.statementsNotEmailed = false;
    this.statementsWithErrors = false;
    this.statementsEmailedWithError = false;
    this.chauffeursWithNotSignedTimesheet = false;
    this.timeSheetsWithIssue = false;
    this.chauffeursReviewNotCompleted = false;
    if (event.checked == false) {
      vm.payrollDisplayDataFilteredVm = vm.payrollDisplayDataVm;
      return;
    }

    vm.payrollDisplayDataFilteredVm = [];
    vm.payrollDisplayDataVm.forEach(r => {
      if (r.warningCount && r.warningCount > 0) {
        vm.payrollDisplayDataFilteredVm.push(r);
      }
    });
  }

  filterChauffeursWithNotSignedTimesheet(vm: IPayrollViewModel, event: any) {
    this.statementsNotCreated = false;
    this.statementsNotEmailed = false;
    this.statementsWithErrors = false;
    this.statementsEmailedWithError = false;
    this.timeSheetsWithIssue = false;
    this.chauffeursReviewNotCompleted = false;

    if (event.checked == false) {
      vm.payrollDisplayDataFilteredVm = vm.payrollDisplayDataVm;
      return;
    }

    vm.payrollDisplayDataFilteredVm = [];
    vm.payrollDisplayDataVm.forEach(r => {
      if (r.notSignedTimeSheetsCount && r.notSignedTimeSheetsCount > 0) {
        vm.payrollDisplayDataFilteredVm.push(r);
      }
    });
  }
  isReviewCompletedCount

  filterIsReviewNotCompletedCount(vm: IPayrollViewModel, event: any) {
    this.statementsNotCreated = false;
    this.statementsNotEmailed = false;
    this.statementsWithErrors = false;
    this.statementsEmailedWithError = false;
    this.timeSheetsWithIssue = false;
    this.chauffeursWithNotSignedTimesheet = false;

    if (event.checked == false) {
      vm.payrollDisplayDataFilteredVm = vm.payrollDisplayDataVm;
      return;
    }

    vm.payrollDisplayDataFilteredVm = [];
    vm.payrollDisplayDataVm.forEach(r => {
      if (!r.isReviewCompleted) {
        vm.payrollDisplayDataFilteredVm.push(r);
      }
    });
  }

  filterTimesheetsWithIssue(vm: IPayrollViewModel, event: any) {
    this.statementsNotCreated = false;
    this.statementsNotEmailed = false;
    this.statementsWithErrors = false;
    this.statementsEmailedWithError = false;
    this.chauffeursWithNotSignedTimesheet = false;
    this.chauffeursReviewNotCompleted = false;

    if (event.checked == false) {
      vm.payrollDisplayDataFilteredVm = vm.payrollDisplayDataVm;
      return;
    }

    vm.payrollDisplayDataFilteredVm = [];
    vm.payrollDisplayDataVm.forEach(r => {
      if (r.timeSheetsIssueCount && r.timeSheetsIssueCount > 0) {
        vm.payrollDisplayDataFilteredVm.push(r);
      }
    });
  }

  private getPayrollViewData$(payrollPeriodId: number, sortByDriverName: boolean = false): Observable<IPayrollViewModel> {
    const initial$ = of({
      workingText: 'Loading Data...'
    });

    const loader$ = this.commonService.getData('PageCommand', 'payroll', 'get-payroll-display-data', { payrollPeriodId: payrollPeriodId, sortByDriverName: sortByDriverName }/*, this.apiPath*/).pipe(
      map((v: IPayrollViewModel) => {
        if (v.workingText)
          return { ...v };
        v.workingText = undefined;

        const ret = { ...v, actionsAllowed: true };
        if (ret.data) {
          ret.payrollDisplayDataVm = ret.data.payrollDisplayData ? ret.data.payrollDisplayData : undefined;
          ret.payrollDisplayDataFilteredVm = ret.data.payrollDisplayData ? ret.data.payrollDisplayData : undefined;
          this.vmi.warningCount = ret.data.payrollDisplayData.filter(p => p.warningCount > 0).length;
          this.vmi.notSignedTimeSheetsCount = ret.data.payrollDisplayData.reduce((sum, p) => sum + (p.notSignedTimeSheetsCount || 0), 0);
          this.vmi.timeSheetsIssueCount = ret.data.payrollDisplayData.reduce((sum, p) => sum + (p.timeSheetsIssueCount || 0), 0);
          this.vmi.isReviewNotCompletedCount = ret.data.payrollDisplayData.reduce((sum, p) => sum + (!p.isReviewCompleted ? 1 : 0), 0);
        }
        console.log('getPayrollViewData', ret, this.vmi.isReviewNotCompletedCount);
        return ret;
      })
    );
    return merge(initial$, loader$);
  }

  private getDriverPayrollForDisplay$(payrollPeriodId: number, payrollPeriodDriverId: number, payrollPeriodDriverDayId: number = 0): Observable<IDriverPayrollViewModel> {
    const initial$ = of({
      workingText: 'Loading Data...'
    });

    const loader$ = this.commonService.getData('PageCommand', 'payroll', 'get-driver-payroll-for-display', { payrollPeriodId: payrollPeriodId, payrollPeriodDriverId: payrollPeriodDriverId, payrollPeriodDriverDayId: payrollPeriodDriverDayId }/*, this.apiPath*/).pipe(
      map((v: IDriverPayrollViewModel) => {
        if (v.workingText)
          return { ...v };
        const ret = { ...v, actionsAllowed: true };
        if (ret.data) {
          ret.driverPayrollDataVm = this.setDriverPayrollDataVm(ret.data.driverPayrollData),
            ret.driverPayrollDataFilteredVm = this.setDriverPayrollDataVm(ret.data.driverPayrollData),
            this.vmi.currentPayrollPeriod.adjustmentsCommited = ret.data.driverPayrollData.adjustmentsCommited,
            this.vmi.showDriverEmailButton = (ret.data.driverPayrollData?.header?.statementEmailStatus ?? 0) == 2 ? true : false;
          this.vmi.statementAvailable = (ret.data.driverPayrollData?.header?.statementStatus ?? 0) == 2 ? true : false;
          this.vmi.driverEmails = ret.data.driverPayrollData?.header?.driverEmails ?? '';
          this.showPayrollInAuditMode = payrollPeriodDriverDayId > 0 ? true : false;

          if ((ret.data?.driverPayrollCompareData ?? []).length > 0) {
            ret.driverPayrollCompareDataVm = {};
            ret.driverPayrollCompareDataVm.data = {};
            ret.driverPayrollCompareDataVm.data.driverPayrollCompareData = ret.data.driverPayrollCompareData;
          }
        }
        console.log('getDriverPayrollForDisplay', ret);
        return ret;
      })
    );
    return merge(initial$, loader$);
  }

  setDriverPayrollDataVm(d: IPayrollDayData): IPayrollDayData {
    const ret: IPayrollDayData = {
      payrollLocation: d.payrollLocation,
      payrollPeriodStartDateTime: d.payrollPeriodStartDateTime,
      payrollPeriodEndtDateTime: d.payrollPeriodEndtDateTime,
      header: d.header,
      payrollDaysData: d.payrollDaysData.map(p => {
        const ret: IPayrollDayDetail = {
          payrollPeriodDriverDayId: p.payrollPeriodDriverDayId,
          payrollDate: p.payrollDate,
          activities: p.activities,
          totals: p.totals,
          activityAdjustment: p.activityAdjustment,
          dayAdjustment: p.dayAdjustment,
          actions: p.actions,
          listIcons: p.listIcons,
          notPricedCount: p.activities.filter(a => a.recordType == '1' && a.isReadyForBilling != true).length,
          timesheetDetails: p?.timesheetDetails ? {
            issuesCount: p.timesheetDetails.issuesCount,
            readyToSignDateTimeUtc: p.timesheetDetails.readyToSignDateTimeUtc,
            signed: p.timesheetDetails.signed,
            signedDateTimeUtc: p.timesheetDetails.signedDateTimeUtc,
            issues: p.timesheetDetails.issues,
            jsonString: p.timesheetDetails.jsonString,
            driverBreakDay: (p.timesheetDetails.jsonString ?? '').length > 0 ? JSON.parse(p.timesheetDetails.jsonString) : undefined
          } : undefined
        }
        return ret;
      }),
      adjustmentsCommited: d.adjustmentsCommited
    };
    return ret;
  }

  exitPayrollView() {
    this.vmi.currentPayrollPeriod.payrollPeriodDriverId = 0;
    this.showPayrollViewModel = true;
    this.showDriverPayrollViewModel = false;
    this.vmi.showDriverEmailButton = false;
    this.vmi.statementAvailable = false;
    this.showPayrollInAuditMode = false;
    this.vmd$ = undefined;
  }

  updatePayrollDayStart(d: IPayrollDayDetail, driverCode: string, payrollPeriodDriverId: number) {
    this.showDriverPayrollViewModel = false;
    this.showPayrollInAuditMode = false;
    this.showPayrollViewModel = false;
    this.vmi.dayFormVm = this.dayFormVm(d, driverCode, payrollPeriodDriverId);
  }

  updatePayrollDayCancel() {
    this.showDriverPayrollViewModel = true;
    this.showPayrollInAuditMode = false;
    this.vmi.dayFormVm = undefined;
  }

  updateReservationStart(a: IPayrollDayActivity, d: IPayrollDayDetail, dd: IPayrollDayData) {
    this.showDriverPayrollViewModel = false;
    this.showPayrollInAuditMode = false;
    this.vmi.reservationFormVm = this.reservationFormVm(a, d, dd);
  }

  updatePayrollReservationCancel() {
    this.showDriverPayrollViewModel = true;
    this.vmi.reservationFormVm = undefined;
  }

  updatePayrollTotalStart(d: IPayrollDayData) {
    this.showDriverPayrollViewModel = false;
    this.showPayrollInAuditMode = false;
    this.showPayrollViewModel = false;
    this.vmi.totalFormVm = this.totalFormVm(d);
  }

  updatePayrollTotalCancel() {
    this.showDriverPayrollViewModel = true;
    this.showPayrollInAuditMode = false;
    this.vmi.totalFormVm = undefined;
  }


  /**
   * 
   */
  reservationFormVm(a: IPayrollDayActivity, d: IPayrollDayDetail, dd: IPayrollDayData): IReservationEntryFormViewModel {

    const data = this.setReservationFormData(a, d, dd);

    console.log('reservationFormVm', a.canMoveTripDateTime);

    const ret: IReservationEntryFormViewModel = {
      data: data,

      isValid: false,
      allowMoveTrip: a.canMoveTrip,
      dateTimeToMove: a.movedPickupDateTime ? a.movedPickupDateTime : a.canMoveTripDateTime ? a.canMoveTripDateTime : undefined,
      moveDateChecked: a.movedPickupDateTime ? true : false,

      okCancelVm: FormOkCancelComponent.okCancelVm({}),

      showOtherReason1: data.miscReason1 == 'other-charge' ? true : false,
      showOtherReason2: data.miscReason2 == 'other-charge' ? true : false,
      showOtherReason3: data.miscReason3 == 'other-charge' ? true : false,

      confirmationNumberVm: FormInputComponent.viewModel(data, 'confirmationNumber', { title: 'Confirmation Number', isRequired: true, isLocked: true }),
      gratuityAmountVm: FormInputComponent.viewModel(data, 'gratuityAmount', { title: 'Gratuity Amount', isRequired: false }),
      parkingAmountVm: FormInputComponent.viewModel(data, 'parkingAmount', { title: 'Parking Amount', isRequired: false }),
      tollAmountVm: FormInputComponent.viewModel(data, 'tollAmount', { title: 'Toll Amount', isRequired: false }),

      miscAmountVm1: FormInputComponent.viewModel(data, 'miscAmount1', { title: 'Additional Charge Amount', isRequired: false }),
      miscReasonVm1: FormSelectComponent.viewModel(data, 'miscReason1',
        { title: 'Additional Charge Reason', isRequired: false, type: 'select' }, this.payrollService.setAdditionalChargeReason()),
      otherReasonVm1: FormInputComponent.viewModel(data, 'otherReason1', { title: 'Please Enter The Reason', isRequired: false }),

      miscAmountVm2: FormInputComponent.viewModel(data, 'miscAmount2', { title: 'Additional Charge Amount', isRequired: false }),
      miscReasonVm2: FormSelectComponent.viewModel(data, 'miscReason2',
        { title: 'Additional Charge Reason', isRequired: false, type: 'select' }, this.payrollService.setAdditionalChargeReason()),
      otherReasonVm2: FormInputComponent.viewModel(data, 'otherReason2', { title: 'Please Enter The Reason', isRequired: false }),

      miscAmountVm3: FormInputComponent.viewModel(data, 'miscAmount3', { title: 'Additional Charge Amount', isRequired: false }),
      miscReasonVm3: FormSelectComponent.viewModel(data, 'miscReason3',
        { title: 'Additional Charge Reason', isRequired: false, type: 'select' }, this.payrollService.setAdditionalChargeReason()),
      otherReasonVm3: FormInputComponent.viewModel(data, 'otherReason3', { title: 'Please Enter The Reason', isRequired: false }),
    };
    return ret;
  }

  moveDateChanged(rvm: IReservationEntryFormViewModel) {
    rvm.data.dateTimeToMove = rvm.moveDateChecked ? rvm.dateTimeToMove : undefined;
    this.resFormValidate(rvm);
  }

  dayFormVm(d: IPayrollDayDetail, driverCode: string, payrollPeriodDriverId: number): IDayEntryFormViewModel {

    const data = this.setDayFormData(d, driverCode, payrollPeriodDriverId);

    const ret: IDayEntryFormViewModel = {
      data: data,

      isValid: false,

      okCancelVm: FormOkCancelComponent.okCancelVm({}),

      showOtherReason1: data.miscReason1 == 'other-charge' ? true : false,
      showOtherReason2: data.miscReason2 == 'other-charge' ? true : false,
      showOtherReason3: data.miscReason3 == 'other-charge' ? true : false,
      showMinOtherReason1: data.additionalMinutesReason1 == 'other-minutes' ? true : false,
      showMinOtherReason2: data.additionalMinutesReason2 == 'other-minutes' ? true : false,
      showMinOtherReason3: data.additionalMinutesReason3 == 'other-minutes' ? true : false,

      driverNumberVm: FormInputComponent.viewModel(data, 'driverNumber', { title: 'Chauffeur Number', isRequired: true, isLocked: true }),
      payrollDateVm: FormInputComponent.viewModel(data, 'payrollDate', { title: 'Payroll Date', isRequired: true, isLocked: true }),
      additionalMinutesVm1: FormInputComponent.viewModel(data, 'additionalMinutes1', { title: 'Additional Minutes', isRequired: false }),
      additionalMinutesReasonVm1: FormSelectComponent.viewModel(data, 'additionalMinutesReason1',
        { title: 'Additional Minutes Reason', isRequired: false, type: 'select' }, this.payrollService.setAdditionalMinutesReason()),
      otherMinReasonVm1: FormInputComponent.viewModel(data, 'additionalMinutesOtherReason1', { title: 'Please Enter The Reason', isRequired: false }),

      additionalMinutesVm2: FormInputComponent.viewModel(data, 'additionalMinutes2', { title: 'Additional Minutes', isRequired: false }),
      additionalMinutesReasonVm2: FormSelectComponent.viewModel(data, 'additionalMinutesReason2',
        { title: 'Additional Minutes Reason', isRequired: false, type: 'select' }, this.payrollService.setAdditionalMinutesReason()),
      otherMinReasonVm2: FormInputComponent.viewModel(data, 'additionalMinutesOtherReason2', { title: 'Please Enter The Reason', isRequired: false }),

      additionalMinutesVm3: FormInputComponent.viewModel(data, 'additionalMinutes3', { title: 'Additional Minutes', isRequired: false }),
      additionalMinutesReasonVm3: FormSelectComponent.viewModel(data, 'additionalMinutesReason3',
        { title: 'Additional Minutes Reason', isRequired: false, type: 'select' }, this.payrollService.setAdditionalMinutesReason()),
      otherMinReasonVm3: FormInputComponent.viewModel(data, 'additionalMinutesOtherReason3', { title: 'Please Enter The Reason', isRequired: false }),

      miscAmountVm1: FormInputComponent.viewModel(data, 'miscAmount1', { title: 'Additional Charge Amount', isRequired: false }),
      miscReasonVm1: FormSelectComponent.viewModel(data, 'miscReason1',
        { title: 'Additional Charge Reason', isRequired: false, type: 'select' }, this.payrollService.setAdditionalChargeReason()),
      otherReasonVm1: FormInputComponent.viewModel(data, 'otherReason1', { title: 'Please Enter The Reason', isRequired: false }),

      miscAmountVm2: FormInputComponent.viewModel(data, 'miscAmount2', { title: 'Additional Charge Amount', isRequired: false }),
      miscReasonVm2: FormSelectComponent.viewModel(data, 'miscReason2',
        { title: 'Additional Charge Reason', isRequired: false, type: 'select' }, this.payrollService.setAdditionalChargeReason()),
      otherReasonVm2: FormInputComponent.viewModel(data, 'otherReason2', { title: 'Please Enter The Reason', isRequired: false }),

      miscAmountVm3: FormInputComponent.viewModel(data, 'miscAmount3', { title: 'Additional Charge Amount', isRequired: false }),
      miscReasonVm3: FormSelectComponent.viewModel(data, 'miscReason3',
        { title: 'Additional Charge Reason', isRequired: false, type: 'select' }, this.payrollService.setAdditionalChargeReason()),
      otherReasonVm3: FormInputComponent.viewModel(data, 'otherReason3', { title: 'Please Enter The Reason', isRequired: false }),

      breakStartInputVm1: FormInputComponent.viewModel(data, 'breakStartTime1', { title: 'Shift Break Start Time', isRequired: false, type: 'time' }),
      breakStartInputVm2: FormInputComponent.viewModel(data, 'breakStartTime2', { title: 'Shift Break Start Time', isRequired: false, type: 'time' }),
      breakEndInputVm1: FormInputComponent.viewModel(data, 'breakEndTime1', { title: 'Shift Break End Time', isRequired: false, type: 'time' }),
      breakEndInputVm2: FormInputComponent.viewModel(data, 'breakEndTime2', { title: 'Shift Break End Time', isRequired: false, type: 'time' }),

      breakDateInputVm1: FormInputComponent.viewModel(data, 'breakDate1', { title: 'Shift Break Date', isRequired: false, type: 'date', isLocked: true }),
      breakDateInputVm2: FormInputComponent.viewModel(data, 'breakDate2', { title: 'Shift Break Date', isRequired: false, type: 'date', isLocked: true }),
    }
    return ret;
  }

  totalFormVm(d: IPayrollDayData): ITotalEntryFormViewModel {

    const data = this.setTotalFormData(d);

    const ret: ITotalEntryFormViewModel = {
      data: data,

      isValid: false,

      okCancelVm: FormOkCancelComponent.okCancelVm({}),

      showOtherReason1: data.miscReason1 == 'other-charge' ? true : false,
      showOtherReason2: data.miscReason2 == 'other-charge' ? true : false,
      showOtherReason3: data.miscReason3 == 'other-charge' ? true : false,

      driverNumberVm: FormInputComponent.viewModel(data, 'driverNumber', { title: 'Chauffeur Number', isRequired: true, isLocked: true }),

      miscAmountVm1: FormInputComponent.viewModel(data, 'miscAmount1', { title: 'Additional Charge Amount', isRequired: false }),
      miscReasonVm1: FormSelectComponent.viewModel(data, 'miscReason1',
        { title: 'Additional Charge Reason', isRequired: false, type: 'select' }, this.payrollService.setAdditionalChargeReason()),
      otherReasonVm1: FormInputComponent.viewModel(data, 'otherReason1', { title: 'Please Enter The Reason', isRequired: false }),

      miscAmountVm2: FormInputComponent.viewModel(data, 'miscAmount2', { title: 'Additional Charge Amount', isRequired: false }),
      miscReasonVm2: FormSelectComponent.viewModel(data, 'miscReason2',
        { title: 'Additional Charge Reason', isRequired: false, type: 'select' }, this.payrollService.setAdditionalChargeReason()),
      otherReasonVm2: FormInputComponent.viewModel(data, 'otherReason2', { title: 'Please Enter The Reason', isRequired: false }),

      miscAmountVm3: FormInputComponent.viewModel(data, 'miscAmount3', { title: 'Additional Charge Amount', isRequired: false }),
      miscReasonVm3: FormSelectComponent.viewModel(data, 'miscReason3',
        { title: 'Additional Charge Reason', isRequired: false, type: 'select' }, this.payrollService.setAdditionalChargeReason()),
      otherReasonVm3: FormInputComponent.viewModel(data, 'otherReason3', { title: 'Please Enter The Reason', isRequired: false })
    }
    return ret;
  }

  progressFormVm(): IProgressFormViewModel {

    const ret: IProgressFormViewModel = {
      message: undefined,
      errorText: undefined,
      valueNow: undefined,
      dataList: []
    }
    return ret;
  }

  progressFormVmClose() {
    if (this.vmi.progressFormVm)
      this.vmi.progressFormVm = undefined;
  }

  // Lock process
  startLockProcess() {
    if (this.vmi.currentPayrollPeriod.payrollPeriodId == 0 || this.vmi.currentPayrollPeriod.payrollPeriodLocked || !this.vmi.currentPayrollPeriod.adjustmentsCommited)
      return;

    this.showPayrollViewModel = false;
    this.vmi.lockFormVm = this.lockFormVm();
  }

  lockFormVm(): ILockEntryFormViewModel {

    const ret: ILockEntryFormViewModel = {
      okCancelVm: FormOkCancelComponent.okCancelVm({})
    }
    return ret;
  }

  /**
   * 
   * @param dvm 
   */
  async lockFormOk() {
    if (this.vmi.currentPayrollPeriod.payrollPeriodId == 0 || this.vmi.currentPayrollPeriod.payrollPeriodLocked || !this.vmi.currentPayrollPeriod.adjustmentsCommited)
      return;

    try {
      this.showPayrollViewModel = false;
      this.vmi.lockFormVm = undefined;
      this.vmi.errorText = undefined;
      this.vmi.progressFormVm = this.progressFormVm();

      // load data, should only get records that didn't have a statement calculated already.
      this.vmi.progressFormVm.message = 'Loading payroll data...';
      const payrollDataItems = await of({}).pipe(
        delay(100),
        switchMap(() => this.getPayrollData$(this.vmi.currentPayrollPeriod.payrollPeriodId, this.vmi.sortByDriverName, true)),
        map(ctx => ctx.payrollDataVm ?? [])
      ).toPromise();

      // setup process
      const fromDate = formatDate(this.vmi.currentPayrollPeriod.startDate, 'MM-dd-yyyy', 'en-US');
      const toDate = formatDate(this.vmi.currentPayrollPeriod.endDate, 'MM-dd-yyyy', 'en-US');
      this.vmi.currentPayrollPeriod.payrollCheckDate = moment(this.vmi.currentPayrollPeriod.payrollCheckDate).format('YYYY-MM-DD');

      var processedCount: number = 0;
      // process each item
      for (let pdiNdx = 0; pdiNdx < payrollDataItems.length; pdiNdx++) {
        const p = payrollDataItems[pdiNdx];

        this.vmi.progressFormVm.message = `Saving Statements for ${p.header.driverNumber}-${p.header.driverName} ...`;

        var fileName = `EmpireCLS-${this.vmi.currentPayrollPeriod.payrollLocation}-PayStatement-${p.header.driverNumber}-${p.header.driverName}-${fromDate}-${toDate}.pdf`;
        const blob = this.payrollService.generatePdfFile([p], fileName, this.vmi.includeTimeSheetPage, this.vmi.currentPayrollPeriod ?? {}, true, true);

        const text = await new Response(blob).text();

        const perc = pdiNdx / payrollDataItems.length * 100;
        this.vmi.progressFormVm.valueNow = perc;

        const saveResult = await of({}).pipe(
          delay(100),
          switchMap(() => this.submitCommandInvoke('save-driver-statement', { payrollPeriodId: this.vmi.currentPayrollPeriod.payrollPeriodId, payrollPeriodDriverId: p.header.payrollPeriodDriverId, fileName: fileName, blob: text }))
        ).toPromise();

        // break on error
        if (saveResult.errorText) {
          this.vmi.progressFormVm.errorText = saveResult.errorText;
          this.vmi.progressFormVm.message = undefined;
          break;
        }
        processedCount++;
      }

      if (this.vmi.progressFormVm.errorText != undefined)
        return;
      if (processedCount != payrollDataItems.length) {
        this.vmi.progressFormVm.errorText = `Not all chauffeur pay statement was processed. ${processedCount} out of ${payrollDataItems.length} was created!`;
        return;
      }

      this.vmi.progressFormVm.message = `Locking Period...`;
      if (this.vmi.progressFormVm.errorText == undefined) {
        const saveResult = await of({}).pipe(
          delay(100),
          switchMap(() => this.submitCommandInvoke('lock-payroll-period', { payrollPeriodId: this.vmi.currentPayrollPeriod.payrollPeriodId }))
        ).toPromise();

        if (saveResult.errorText) {
          this.vmi.progressFormVm.errorText = saveResult.errorText;
          this.vmi.progressFormVm.message = undefined;
        }
      }

    } catch (err) {
      this.vmi.progressFormVm.errorText = err;
      this.vmi.progressFormVm.message = undefined;
    } finally {
      if (this.vmi.progressFormVm.errorText == undefined) {
        this.vmi.progressFormVm.message = 'Completed...';
        this.vmi.progressFormVm.errorText = undefined;
      }
    }

    if (this.vmi.progressFormVm.errorText == undefined) {
      setTimeout(() => {
        if (this.vmi.progressFormVm)
          this.vmi.progressFormVm = undefined;
        this.refreshPage();
      }, 2000);
    }
  }

  /**
   * 
   * @param dvm 
   */
  async onReviewCompletedCheck(vmd: IDriverPayrollViewModel) {
    if (this.vmi.currentPayrollPeriod.payrollPeriodId == 0 || this.vmi.currentPayrollPeriod.payrollPeriodLocked 
        || vmd.driverPayrollDataFilteredVm.header.payrollPeriodDriverId == 0)
      return;
    
    const saveResult = await of({}).pipe(
      delay(100),
      switchMap(() => this.submitCommandInvoke('update-review-completed-flag', 
        { payrollPeriodId: this.vmi.currentPayrollPeriod.payrollPeriodId, 
          payrollPeriodDriverId: vmd.driverPayrollDataFilteredVm.header.payrollPeriodDriverId,
          isReviewCompleted: vmd.driverPayrollDataFilteredVm.header.isReviewCompleted
        }))
    ).toPromise();

    if (saveResult.errorText) {
      vmd.errorText = saveResult.errorText;
      return;
    }
    this.vmd$ = this.getDriverPayrollForDisplay$(this.vmi.currentPayrollPeriod.payrollPeriodId, vmd.driverPayrollDataFilteredVm.header.payrollPeriodDriverId);
  }

  lockFormCanceled() {
    this.showPayrollViewModel = true;
    this.vmi.lockFormVm = undefined;
  }

  showIssueList(d: IPayrollDayDetail): boolean {
    if (d.timesheetDetails == undefined) {
      if (d.notPricedCount > 0)
        return true;
      return false;
    }

    if (d.timesheetDetails?.issues.notPriced || d.timesheetDetails?.issues.dayTooLong)
      return true;

    return false;
  }
  buildIssueList(d: IPayrollDayDetail): string {
    let ret: string = '';

    if (d.timesheetDetails == undefined) {
      if (d.notPricedCount > 0)
        ret = `Final charges have not been set on certain reservations.`;
      return ret;
    }

    if (d.timesheetDetails?.issues.notPriced)
      ret = `Final charges have not been set on certain reservations.`;
    if (d.timesheetDetails?.issues.dayTooLong) {
      if (ret.length > 0)
        ret += ' ';
      ret += `The day is to long`;
    }

    return ret;
  }

  showNotesFromChauffeur(ts: ITimesheetDetail): boolean {
    if (ts == undefined)
      return false;

    if ((ts.driverBreakDay?.dayInfo?.reviewInfo?.comment ?? '').length > 0 ||
      (ts.driverBreakDay?.restBreakInfo?.reviewInfo?.comment ?? '').length > 0 ||
      (ts.driverBreakDay?.mealBreakInfo?.reviewInfo?.comment ?? '').length > 0 ||
      (ts.driverBreakDay?.signInfo?.reviewInfo?.comment ?? '').length > 0 ||
      (ts.driverBreakDay?.signInfo?.comment ?? '').length > 0) {
      return true;
    }
    return false;
  }

  buildNotesFromChauffeur(bd: IDriverBreakDay): string {
    let ret: string = '';

    if ((bd.dayInfo?.reviewInfo?.comment ?? '').length > 0) {
      ret = `[Day]: ${bd.dayInfo.reviewInfo.comment}`;
    }
    if ((bd.restBreakInfo?.reviewInfo?.comment ?? '').length > 0) {
      if (ret.length > 0)
        ret += '; ';
      ret += `[Rest Break]: ${bd.restBreakInfo.reviewInfo.comment}`;
    }
    if ((bd.mealBreakInfo?.reviewInfo?.comment ?? '').length > 0) {
      if (ret.length > 0)
        ret += '; ';
      ret += `[Meal Break]: ${bd.mealBreakInfo.reviewInfo.comment}`;
    }
    if ((bd.signInfo?.reviewInfo?.comment ?? '').length > 0) {
      if (ret.length > 0)
        ret += '; ';
      ret += `[Sign]: ${bd.signInfo.reviewInfo.comment}`;
    }
    if ((bd.signInfo?.comment ?? '').length > 0) {
      if (ret.length > 0)
        ret += '; ';
      ret += `[Sign]: ${bd.signInfo.comment}`;
    }

    return ret;
  }

  ///////////////////////

  // Email Statement screen

  startEmailProcess() {

    if (this.vmi.currentPayrollPeriod.payrollPeriodId == 0) {
      this.showActionErrorMessage('Payroll period not selected');
      return;
    }
    if (!this.vmi.currentPayrollPeriod.payrollPeriodLocked) {
      this.showActionErrorMessage('Payroll period not locked');
      return;
    }
    if (!this.vmi.currentPayrollPeriod.adjustmentsCommited) {
      this.showActionErrorMessage('Payroll period adjustments not commited');
      return;
    }
    if (this.vmi.currentPayrollPeriod.statementCreated != this.vmi.currentPayrollPeriod.totalDriversInPeriod) {
      this.showActionErrorMessage('Payroll period statements not completed');
      return;
    }

    this.showPayrollViewModel = false;
    this.vmi.emailFormVm = this.emailFormVm('all-statements', { emailAddress1: '', emailAddress2: '' });
  }

  emailFormVm(type: string, data: IEmailEntryFormData): IEmailEntryFormViewModel {

    const ret: IEmailEntryFormViewModel = {
      data: data,
      viewType: type,
      emailAddressVm1: type == 'all-statements' ? undefined : FormInputComponent.viewModel(data, 'emailAddress1', { title: 'Email Address', isRequired: true, isLocked: false }),
      emailAddressVm2: type == 'all-statements' ? undefined : FormInputComponent.viewModel(data, 'emailAddress2', { title: 'Email Address', isRequired: false, isLocked: false }),
      okCancelVm: FormOkCancelComponent.okCancelVm({}),
      isValid: (data.emailAddress1 ?? '').length > 0 ? true : false
    }
    return ret;
  }

  /**
   * 
   * @param dvm 
   */
  async emailFormOk(dvm: IDayEntryFormViewModel) {

    if (this.vmi.currentPayrollPeriod.payrollPeriodId == 0 || !this.vmi.currentPayrollPeriod.payrollPeriodLocked
      || !this.vmi.currentPayrollPeriod.adjustmentsCommited || this.vmi.currentPayrollPeriod.statementCreated != this.vmi.currentPayrollPeriod.totalDriversInPeriod)
      return;

    try {
      this.showPayrollViewModel = false;
      this.vmi.emailFormVm = undefined;
      this.vmi.errorText = undefined;
      this.vmi.progressFormVm = this.progressFormVm();

      this.vmi.progressFormVm.message = 'Loading payroll data...';
      const payrollDataItems = await of({}).pipe(
        delay(100),
        switchMap(() => this.getPayrollData$(this.vmi.currentPayrollPeriod.payrollPeriodId, this.vmi.sortByDriverName, false, true)),
        map(ctx => ctx.payrollDataVm ?? [])
      ).toPromise();

      this.vmi.progressFormVm.message = 'Validate emails...';
      // check if all drivers have email addresses
      payrollDataItems.forEach(e => {
        if ((e.header.driverEmails ?? "").length == 0) {
          this.vmi.progressFormVm.dataList.push({ column1: e.header.driverNumber, column2: e.header.driverName });
        }
      });

      /*if (this.vmi.progressFormVm.dataList.length > 0) {
        this.vmi.progressFormVm.message = undefined;
        this.vmi.progressFormVm.errorText = `Here is the ${this.vmi.progressFormVm.dataList.length} chauffeurs with missed emails. Please fix before email the pay statements.`;
        return;
      }*/

      var processedCount: number = 0;
      // process each item
      for (let pdiNdx = 0; pdiNdx < payrollDataItems.length; pdiNdx++) {
        const p = payrollDataItems[pdiNdx];

        this.vmi.progressFormVm.message = `Emailing Statements for ${p.header.driverNumber}-${p.header.driverName} ...`;

        const perc = pdiNdx / payrollDataItems.length * 100;
        this.vmi.progressFormVm.valueNow = perc;

        const saveResult = await of({}).pipe(
          delay(100),
          switchMap(() => this.submitCommandInvoke('email-driver-statement', { payrollPeriodId: this.vmi.currentPayrollPeriod.payrollPeriodId, payrollPeriodDriverId: p.header.payrollPeriodDriverId, driverId: p.header.driverId }))
        ).toPromise();
        // break on error
        //if (saveResult.errorText) {
        //  this.vmi.progressFormVm.errorText = saveResult.errorText;
        //  this.vmi.progressFormVm.message = undefined;
        //  break;
        //}  
        processedCount++;
      }

      if (this.vmi.progressFormVm.errorText != undefined)
        return;
      if (processedCount != payrollDataItems.length) {
        this.vmi.progressFormVm.errorText = `Not all chauffeur pay statement was processed. ${processedCount} out of ${payrollDataItems.length} was sent!`;
        return;
      }

    } catch (err) {
      this.vmi.progressFormVm.errorText = err;
      this.vmi.progressFormVm.message = undefined;
    } finally {
      if (this.vmi.progressFormVm.errorText == undefined) {
        this.vmi.progressFormVm.message = 'Completed...';
        this.vmi.progressFormVm.errorText = undefined;
      }
    }

    if (this.vmi.progressFormVm.errorText == undefined) {
      setTimeout(() => {
        if (this.vmi.progressFormVm)
          this.vmi.progressFormVm = undefined;
        this.refreshPage();
      }, 2000);
    }
  }


  emailFormCanceled() {
    this.showPayrollViewModel = true;
    this.vmi.emailFormVm = undefined;
  }

  startemailDriverStatementProcess() {
    if (this.vmi.currentPayrollPeriod.payrollPeriodId == 0 || this.vmi.currentPayrollPeriod.payrollPeriodDriverId == 0)
      return;

    this.showPayrollViewModel = false;
    this.showDriverPayrollViewModel = false;
    this.showPayrollInAuditMode = false;
    var addrs = this.vmi.driverEmails.split(";", 2);
    this.vmi.emailFormVm = this.emailFormVm('statement', { emailAddress1: addrs?.length > 0 ? addrs[0] : '', emailAddress2: addrs?.length > 1 ? addrs[1] : '' });
  }

  /**
   * 
   * @param vm 
   */
  async emailDriverFormOk(vm: IEmailEntryFormViewModel) {

    if (vm.data.emailAddress1.length == 0 && vm.data.emailAddress2.length == 0) {
      this.showActionErrorMessage('The email addresses missed');
      return;
    }

    try {
      this.showPayrollViewModel = false;
      this.vmi.emailFormVm = undefined;
      this.vmi.errorText = undefined;
      this.vmi.progressFormVm = this.progressFormVm();

      this.vmi.progressFormVm.message = 'Loading payroll data...';
      const payrollDataItems = await of({}).pipe(
        delay(100),
        switchMap(() => this.getPayrollData$(this.vmi.currentPayrollPeriod.payrollPeriodId, this.vmi.sortByDriverName, false, false, this.vmi.currentPayrollPeriod.payrollPeriodDriverId)),
        map(ctx => ctx.payrollDataVm ?? [])
      ).toPromise();

      var processedCount: number = 0;
      // process each item
      for (let pdiNdx = 0; pdiNdx < payrollDataItems.length; pdiNdx++) {
        const p = payrollDataItems[pdiNdx];

        this.vmi.progressFormVm.message = `Emailing Statements for ${p.header.driverNumber}-${p.header.driverName} ...`;

        const perc = pdiNdx / payrollDataItems.length * 100;
        this.vmi.progressFormVm.valueNow = perc;

        const saveResult = await of({}).pipe(
          delay(100),
          switchMap(() => this.submitCommandInvoke('email-driver-statement', {
            payrollPeriodId: this.vmi.currentPayrollPeriod.payrollPeriodId,
            payrollPeriodDriverId: p.header.payrollPeriodDriverId,
            driverId: p.header.driverId,
            resend: true,
            emailAddress1: vm.data.emailAddress1,
            emailAddress2: vm.data.emailAddress2
          }))
        ).toPromise();
        // break on error
        if (saveResult.errorText) {
          this.vmi.progressFormVm.errorText = saveResult.errorText;
          this.vmi.progressFormVm.message = undefined;
          break;
        }
        processedCount++;
      }

      if (this.vmi.progressFormVm.errorText != undefined)
        return;
      if (processedCount != payrollDataItems.length) {
        this.vmi.progressFormVm.errorText = `Not all chauffeur pay statement was processed. ${processedCount} out of ${payrollDataItems.length} was sent!`;
        return;
      }

    } catch (err) {
      this.vmi.progressFormVm.errorText = err;
      this.vmi.progressFormVm.message = undefined;
    } finally {
      if (this.vmi.progressFormVm.errorText == undefined) {
        this.vmi.progressFormVm.message = 'Completed...';
        this.vmi.progressFormVm.errorText = undefined;
      }
    }

    if (this.vmi.progressFormVm.errorText == undefined) {
      setTimeout(() => {
        if (this.vmi.progressFormVm)
          this.vmi.progressFormVm = undefined;
        this.showDriverPayrollViewModel = true;
        this.showPayrollInAuditMode = false;
      }, 2000);
    }
  }

  emailFormValidate(vm: IEmailEntryFormViewModel) {
    var ret: boolean = false;
    var emailCheck = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
    if (vm.data?.emailAddress1?.length > 0) {
      ret = emailCheck.test(vm.data.emailAddress1);
    }
    vm.isValid = ret;
  }

  emailDriverFormCanceled() {
    this.showDriverPayrollViewModel = true;
    this.vmi.emailFormVm = undefined;
    this.showPayrollInAuditMode = false;
  }

  ///////////

  // calculate screen

  /**
   * 
   */
  startCalculateProcess() {
    this.showPayrollViewModel = false;
    this.vmi.calcFormVm = this.calculateFormVm();
  }

  /**
   * 
   * @returns 
   */
  calculateFormVm(): ICalcEntryFormViewModel {

    const data = this.setCalculateFormData();

    const ret: ICalcEntryFormViewModel = {
      data: data,

      okCancelVm: FormOkCancelComponent.okCancelVm({}),

      emailAddressVm: FormInputComponent.viewModel(data, 'emailAddress', { title: 'Email Address', isRequired: false, isLocked: false }),

      isValid: true
    }
    return ret;
  }

  /**
   * 
   * @returns 
   */
  setCalculateFormData(): ICalcEntryFormData {
    return {
      emailAddress: ''
    };
  }

  /**
   * 
   * @param dvm 
   */
  async calculateFormOk(cvm: ICalcEntryFormViewModel) {

    const success = await FormOkCancelComponent.processOkAsync(cvm.okCancelVm, 'Submitting...',
      () => this.submitCommandInvoke('recalc-payroll-period', { payrollPeriodId: this.vmi.currentPayrollPeriod.payrollPeriodId, emailAddressToNotify: cvm.data.emailAddress }));

    if (success) {
      this.showPayrollViewModel = true;
      this.vmi.reservationFormVm = undefined;
      this.vm$ = this.loadPage$();
    }

    this.showPayrollViewModel = true;
    this.vmi.calcFormVm = undefined;
  }

  /**
   * 
   */
  calculateFormCanceled() {
    this.showPayrollViewModel = true;
    this.vmi.calcFormVm = undefined;
  }

  /**
   * 
   * @param vm 
   * @param fvm 
   */
  calculateFormValidate(vm: IPayrollPageViewModel, cvm: ICalcEntryFormViewModel) {
    var ret: boolean = true;
    if (cvm.data?.emailAddress?.length > 0) {
      var emailCheck = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
      ret = emailCheck.test(cvm.data.emailAddress);
    }
    cvm.isValid = ret;
  }

  //////////////////////////////////////////

  /**
   * 
   * @param dvm 
   */
  dayFormValidate(dvm: IDayEntryFormViewModel) {

    dvm.isValid = false;
    dvm.isValid = this.validateInputData(dvm.data.additionalMinutes1, dvm.data.additionalMinutesReason1, dvm.showMinOtherReason1, dvm.data.additionalMinutesOtherReason1, true)
      || this.validateInputData(dvm.data.additionalMinutes2, dvm.data.additionalMinutesReason2, dvm.showMinOtherReason2, dvm.data.additionalMinutesOtherReason2, true)
      || this.validateInputData(dvm.data.additionalMinutes3, dvm.data.additionalMinutesReason3, dvm.showMinOtherReason3, dvm.data.additionalMinutesOtherReason3, true)
      || this.validateInputData(dvm.data.miscAmount1, dvm.data.miscReason1, dvm.showOtherReason1, dvm.data.otherReason1)
      || this.validateInputData(dvm.data.miscAmount2, dvm.data.miscReason2, dvm.showOtherReason2, dvm.data.otherReason2)
      || this.validateInputData(dvm.data.miscAmount3, dvm.data.miscReason3, dvm.showOtherReason3, dvm.data.otherReason3)
      || this.validateBreakInputData(dvm.data.payrollDate, dvm.data.breakDate1, dvm.data.breakStartTime1, dvm.data.breakEndTime1)
      || this.validateBreakInputData(dvm.data.payrollDate, dvm.data.breakDate2, dvm.data.breakStartTime2, dvm.data.breakEndTime2);

    dvm.isValid = this.isDateHasDash(dvm.isValid, dvm.data.miscAmount1);
    dvm.isValid = this.isDateHasDash(dvm.isValid, dvm.data.miscAmount2);
    dvm.isValid = this.isDateHasDash(dvm.isValid, dvm.data.miscAmount3);
  }

  /**
   * 
   * @param dvm 
   */
  totalFormValidate(tvm: ITotalEntryFormViewModel) {

    tvm.isValid = this.validateInputData(tvm.data.miscAmount1, tvm.data.miscReason1, tvm.showOtherReason1, tvm.data.otherReason1)
      || this.validateInputData(tvm.data.miscAmount2, tvm.data.miscReason2, tvm.showOtherReason2, tvm.data.otherReason2)
      || this.validateInputData(tvm.data.miscAmount3, tvm.data.miscReason3, tvm.showOtherReason3, tvm.data.otherReason3);
  }

  /**
   * 
   * @param dvm 
   */
  resFormValidate(rvm: IReservationEntryFormViewModel) {

    const addlPay = this.validateInputData(rvm.data.miscAmount1, rvm.data.miscReason1, rvm.showOtherReason1, rvm.data.otherReason1)
      || this.validateInputData(rvm.data.miscAmount2, rvm.data.miscReason2, rvm.showOtherReason2, rvm.data.otherReason2)
      || this.validateInputData(rvm.data.miscAmount3, rvm.data.miscReason3, rvm.showOtherReason3, rvm.data.otherReason3);
    const chg = (
      (rvm.data.parkingAmount ?? '').length > 0
      || (rvm.data.gratuityAmount ?? '').length > 0
      || (rvm.data.tollAmount ?? '').length > 0
    );

    const dch = rvm.data.dateTimeToMove == rvm.dateTimeToMove ? true : false;

    rvm.isValid = addlPay || chg || dch;
  }

  validateInputData(value: string, reason: string, showOtherReason: boolean, otherReason: string, ignoreDashValidation: boolean = false): boolean {
    if (showOtherReason) {
      if ((value ?? '').trim().length > 0 && (reason ?? '').trim().length > 0 && (otherReason ?? '').trim().length > 0) {
        if (ignoreDashValidation || value.charAt(0) != '-')
          return true;
      }
      return false;
    }
    if ((value ?? '').length > 0 && (reason ?? '').length > 0) {
      if (ignoreDashValidation || value.charAt(0) != '-')
        return true;
    }
    return false;
  };

  isDateHasDash(origStatus: boolean, value: string): boolean {
    if ((value ?? '').length > 0) {
      if (value.charAt(0) === '-')
        return false;
    }
    return origStatus;
  }

  validateBreakInputData(payrollDate: string, date: string, startTime: string, endTime: string): boolean {
    if ((startTime ?? '').length > 0 && (endTime ?? '').length > 0) {
      return DateUtil.compareTimes(startTime, endTime);
    }
    return false;
  }

  setDayFormData(d: IPayrollDayDetail, driverCode: string, payrollPeriodDriverId: number): IDayEntryFormData {

    var additionalMinutes: any[] = [];
    if (d?.dayAdjustment?.adjustments) {
      d?.dayAdjustment.adjustments.forEach(am => {
        if (am.intValue != 0) {
          additionalMinutes.push({ minutes: am.intValue, reason: am.code, other: am.stringValue });
        }
      });
    }

    var miscAmounts: any[] = [];
    if (d?.dayAdjustment?.adjustments) {
      d?.dayAdjustment.adjustments.forEach(am => {
        if (am.decimalValue != 0) {
          miscAmounts.push({ amount: am.decimalValue, reason: am.code, other: am.stringValue });
        }
      });
    }

    const breakStartTime1 = (d?.dayAdjustment.adjustments ?? []).find(items => items.code == 'break-start-time-1');
    const breakStartTime2 = (d?.dayAdjustment.adjustments ?? []).find(items => items.code == 'break-start-time-2');
    const breakEndTime1 = (d?.dayAdjustment.adjustments ?? []).find(items => items.code == 'break-end-time-1');
    const breakEndTime2 = (d?.dayAdjustment.adjustments ?? []).find(items => items.code == 'break-end-time-2');
    const breakDate1 = (d?.dayAdjustment.adjustments ?? []).find(items => items.code == 'break-date-1');
    const breakDate2 = (d?.dayAdjustment.adjustments ?? []).find(items => items.code == 'break-date-2');

    moment.locale('en-US');
    return {
      payrollPeriodId: this.vmi.currentPayrollPeriod.payrollPeriodId,
      payrollPeriodDriverDayId: d.payrollPeriodDriverDayId,
      payrollDate: moment(d.payrollDate).format('L'),
      driverNumber: driverCode,
      payrollPeriodDriverId: payrollPeriodDriverId,

      additionalMinutes1: additionalMinutes && additionalMinutes.length > 0 ? `${additionalMinutes[0].minutes}` : '',
      additionalMinutesReason1: additionalMinutes && additionalMinutes.length > 0 ? additionalMinutes[0].reason : '',
      additionalMinutesOtherReason1: additionalMinutes && additionalMinutes.length > 0 && additionalMinutes[0].reason && additionalMinutes[0].reason == 'other-minutes' ? additionalMinutes[0].other : '',

      additionalMinutes2: additionalMinutes && additionalMinutes.length > 1 ? `${additionalMinutes[1].minutes}` : '',
      additionalMinutesReason2: additionalMinutes && additionalMinutes.length > 1 ? additionalMinutes[1].reason : '',
      additionalMinutesOtherReason2: additionalMinutes && additionalMinutes.length > 1 && additionalMinutes[1].reason && additionalMinutes[1].reason == 'other-minutes' ? additionalMinutes[1].other : '',

      additionalMinutes3: additionalMinutes && additionalMinutes.length > 2 ? `${additionalMinutes[2].minutes}` : '',
      additionalMinutesReason3: additionalMinutes && additionalMinutes.length > 2 ? additionalMinutes[2].reason : '',
      additionalMinutesOtherReason3: additionalMinutes && additionalMinutes.length > 2 && additionalMinutes[2].reason && additionalMinutes[2].reason == 'other-minutes' ? additionalMinutes[2].other : '',

      miscAmount1: miscAmounts && miscAmounts.length > 0 && miscAmounts[0].amount ? `${miscAmounts[0].amount}` : '',
      miscReason1: miscAmounts && miscAmounts.length > 0 && miscAmounts[0].reason ? miscAmounts[0].reason : '',
      otherReason1: miscAmounts && miscAmounts.length > 0 && miscAmounts[0].reason && miscAmounts[0].reason == 'other-charge' ? miscAmounts[0].other : '',

      miscAmount2: miscAmounts && miscAmounts.length > 1 && miscAmounts[1].amount ? `${miscAmounts[1].amount}` : '',
      miscReason2: miscAmounts && miscAmounts.length > 1 && miscAmounts[1].reason ? miscAmounts[1].reason : '',
      otherReason2: miscAmounts && miscAmounts.length > 1 && miscAmounts[1].reason && miscAmounts[1].reason == 'other-charge' ? miscAmounts[0].other : '',

      miscAmount3: miscAmounts && miscAmounts.length > 2 && miscAmounts[2].amount ? `${miscAmounts[2].amount}` : '',
      miscReason3: miscAmounts && miscAmounts.length > 2 && miscAmounts[2].reason ? miscAmounts[2].reason : '',
      otherReason3: miscAmounts && miscAmounts.length > 2 && miscAmounts[2].reason && miscAmounts[2].reason == 'other-charge' ? miscAmounts[0].other : '',

      breakStartTime1: breakStartTime1 != undefined ? (breakStartTime1?.stringValue ?? '') : '',
      breakStartTime2: breakStartTime2 != undefined ? (breakStartTime2?.stringValue ?? '') : '',
      breakEndTime1: breakEndTime1 != undefined ? (breakEndTime1?.stringValue ?? '') : '',
      breakEndTime2: breakEndTime2 != undefined ? (breakEndTime2?.stringValue ?? '') : '',

      breakDate1: breakDate1 != undefined ? (breakDate1?.stringValue ?? '') : moment(d.payrollDate).format('YYYY-MM-DD'),
      breakDate2: breakDate2 != undefined ? (breakDate2?.stringValue ?? '') : moment(d.payrollDate).format('YYYY-MM-DD')
    };
  }

  setTotalFormData(d: IPayrollDayData): ITotalEntryFormData {

    var miscAmounts: any[] = [];
    if ((d?.header?.totalAdjustment?.adjustments ?? []).length > 0) {
      d.header.totalAdjustment.adjustments.forEach(am => {
        if (am.decimalValue > 0) {
          miscAmounts.push({ amount: am.decimalValue, reason: am.code, other: am.stringValue });
        }
      });
    }

    moment.locale('en-US');
    return {
      payrollPeriodId: this.vmi.currentPayrollPeriod.payrollPeriodId,
      driverNumber: d?.header?.driverNumber ?? '',
      payrollPeriodDriverId: d?.header?.payrollPeriodDriverId ?? 0,

      miscAmount1: miscAmounts && miscAmounts.length > 0 && miscAmounts[0].amount ? `${miscAmounts[0].amount}` : '',
      miscReason1: miscAmounts && miscAmounts.length > 0 && miscAmounts[0].reason ? miscAmounts[0].reason : '',
      otherReason1: miscAmounts && miscAmounts.length > 0 && miscAmounts[0].reason && miscAmounts[0].reason == 'other-charge' ? miscAmounts[0].other : '',

      miscAmount2: miscAmounts && miscAmounts.length > 1 && miscAmounts[1].amount ? `${miscAmounts[1].amount}` : '',
      miscReason2: miscAmounts && miscAmounts.length > 1 && miscAmounts[1].reason ? miscAmounts[1].reason : '',
      otherReason2: miscAmounts && miscAmounts.length > 1 && miscAmounts[1].reason && miscAmounts[1].reason == 'other-charge' ? miscAmounts[0].other : '',

      miscAmount3: miscAmounts && miscAmounts.length > 2 && miscAmounts[2].amount ? `${miscAmounts[2].amount}` : '',
      miscReason3: miscAmounts && miscAmounts.length > 2 && miscAmounts[2].reason ? miscAmounts[2].reason : '',
      otherReason3: miscAmounts && miscAmounts.length > 2 && miscAmounts[2].reason && miscAmounts[2].reason == 'other-charge' ? miscAmounts[0].other : ''
    };
  }

  setReservationFormData(a: IPayrollDayActivity, d: IPayrollDayDetail, dd: IPayrollDayData): IReservationEntryFormData {

    const toll = (d?.activityAdjustment.adjustments ?? []).map(items => items.adjustmentsData.find(t => t.code == 'toll'));
    const gratuity = (d?.activityAdjustment.adjustments ?? []).map(items => items.adjustmentsData.find(t => t.code == 'gratuity'));
    const parking = (d?.activityAdjustment.adjustments ?? []).map(items => items.adjustmentsData.find(t => t.code == 'parking'));

    const misc = (d?.activityAdjustment.adjustments ?? []).filter(t => t.segmentRowId == a.segmentRowId).map(t => t.adjustmentsData.filter(t =>
      t.code != 'toll' && t.code != 'gratuity' && t.code != 'parking' && t.code != 'break-start-time-1' && t.code != 'break-start-time-2' && t.code != 'break-end-time-1' && t.code != 'break-end-time-2'))[0];

    return {
      payrollPeriodId: this.vmi.currentPayrollPeriod.payrollPeriodId,
      payrollPeriodDriverDayId: d.payrollPeriodDriverDayId,
      payrollPeriodDriverId: dd.header.payrollPeriodDriverId,
      segmentRowId: a.segmentRowId,
      confirmationNumber: a.confirmationNumber,
      gratuityAmount: gratuity != undefined && gratuity?.length > 0 ? `${gratuity[0]?.decimalValue ?? ''}` : '',
      tollAmount: toll != undefined && toll?.length > 0 ? `${toll[0]?.decimalValue ?? ''}` : '',
      parkingAmount: parking != undefined && parking?.length > 0 ? `${parking[0]?.decimalValue ?? ''}` : '',

      miscAmount1: misc != undefined && misc.length > 0 ? `${misc[0]?.decimalValue ?? ''}` : '',
      miscReason1: misc != undefined && misc.length > 0 ? misc[0]?.code ?? '' : '',
      otherReason1: misc != undefined && misc.length > 0 && misc[0].code && misc[0].code == 'other-charge' ? (misc[0]?.stringValue ?? '') : '',

      miscAmount2: misc != undefined && misc.length > 1 ? `${misc[1]?.decimalValue ?? ''}` : '',
      miscReason2: misc != undefined && misc.length > 1 ? misc[1]?.code ?? '' : '',
      otherReason2: misc != undefined && misc.length > 1 && misc[1].code && misc[1].code == 'other-charge' ? (misc[1]?.stringValue ?? '') : '',

      miscAmount3: misc != undefined && misc.length > 2 ? `${misc[2]?.decimalValue ?? ''}` : '',
      miscReason3: misc != undefined && misc.length > 2 ? misc[2]?.code ?? '' : '',
      otherReason3: misc != undefined && misc.length > 2 && misc[2].code && misc[2].code == 'other-charge' ? (misc[2]?.stringValue ?? '') : ''
    };
  }

  /**
   * 
   * @param rvm 
   */
  async reservationFormOk(rvm: IReservationEntryFormViewModel) {
    const success = await FormOkCancelComponent.processOkAsync(rvm.okCancelVm, 'Submitting...',
      () => this.submitCommandInvoke('payroll-res-charges-submit', rvm.data));

    if (success) {
      this.showDriverPayrollViewModel = true;
      this.vmi.reservationFormVm = undefined;
      this.showPayrollInAuditMode = false;
      this.vmd$ = this.getDriverPayrollForDisplay$(rvm.data.payrollPeriodId, rvm.data.payrollPeriodDriverId);
    }
  }

  /**
   * 
   * @param dvm 
   */
  async dayFormOk(dvm: IDayEntryFormViewModel) {
    const success = await FormOkCancelComponent.processOkAsync(dvm.okCancelVm, 'Submitting...',
      () => this.submitCommandInvoke('payroll-day-charges-submit', dvm.data));

    if (success) {
      this.showDriverPayrollViewModel = true;
      this.showPayrollInAuditMode = false;
      this.vmi.dayFormVm = undefined;
      this.vmd$ = this.getDriverPayrollForDisplay$(dvm.data.payrollPeriodId, dvm.data.payrollPeriodDriverId);
    }
  }

  /**
   * 
   * @param dvm 
   */
  async totalFormOk(dvm: ITotalEntryFormViewModel) {
    const success = await FormOkCancelComponent.processOkAsync(dvm.okCancelVm, 'Submitting...',
      () => this.submitCommandInvoke('payroll-total-charges-submit', dvm.data));

    if (success) {
      this.showDriverPayrollViewModel = true;
      this.vmi.totalFormVm = undefined;
      this.showPayrollInAuditMode = false;
      this.vmd$ = this.getDriverPayrollForDisplay$(dvm.data.payrollPeriodId, dvm.data.payrollPeriodDriverId);
    }
  }

  /**
   * 
   * @param e 
   * @param index 
   * @param dvm 
   */
  dayReasonChanged(e: IFormSelectChangedArg, index: number, dvm: IDayEntryFormViewModel) {
    if ((index ?? 0) > 0) {
      switch (index) {
        case 1:
          dvm.showOtherReason1 = e.option.value == 'other-charge' ? true : false;
          dvm.showMinOtherReason1 = e.option.value == 'other-minutes' ? true : false;
          break;
        case 2:
          dvm.showOtherReason2 = e.option.value == 'other-charge' ? true : false;
          dvm.showMinOtherReason2 = e.option.value == 'other-minutes' ? true : false;
          break;
        case 3:
          dvm.showOtherReason3 = e.option.value == 'other-charge' ? true : false;
          dvm.showMinOtherReason3 = e.option.value == 'other-minutes' ? true : false;
          break;
      }
    }
    this.dayFormValidate(dvm);
  }

  /**
   * 
   * @param e 
   * @param index 
   * @param dvm 
   */
  totalReasonChanged(e: IFormSelectChangedArg, index: number, tvm: ITotalEntryFormViewModel) {
    if ((index ?? 0) > 0) {
      switch (index) {
        case 1:
          tvm.showOtherReason1 = e.option.value == 'other-charge' ? true : false;
          break;
        case 2:
          tvm.showOtherReason2 = e.option.value == 'other-charge' ? true : false;
          break;
        case 3:
          tvm.showOtherReason3 = e.option.value == 'other-charge' ? true : false;
          break;
      }
    }
    this.totalFormValidate(tvm);
  }

  resReasonChanged(e: IFormSelectChangedArg, index: number, rvm: IReservationEntryFormViewModel) {
    if ((index ?? 0) > 0) {
      switch (index) {
        case 1:
          rvm.showOtherReason1 = e.option.value == 'other-charge' ? true : false;
          break;
        case 2:
          rvm.showOtherReason2 = e.option.value == 'other-charge' ? true : false;
          break;
        case 3:
          rvm.showOtherReason3 = e.option.value == 'other-charge' ? true : false;
          break;
      }
    }
    this.resFormValidate(rvm);
  }
  // Payroll view End

  setRegularAmount(d: IPayrollDayData): number {
    var amt: number = 0;
    d.payrollDaysData.forEach(t => {
      amt += t.totals.regularMinutes;
    })
    return amt;
  }

  setReportingAmount(d: IPayrollDayData): number {
    var amt: number = 0;
    d.payrollDaysData.forEach(t => {
      amt += t.totals.reportingMinutes;
    })
    return amt;
  }

  setPenaltyMealBreakAmount(d: IPayrollDayData): number {
    var amt: number = 0;
    d.payrollDaysData.forEach(t => {
      amt += t.totals.penaltyBreakMinutes;
    })
    return amt;
  }

  setPenaltyRestBreakAmount(d: IPayrollDayData): number {
    var amt: number = 0;
    d.payrollDaysData.forEach(t => {
      amt += t.totals.restPenaltyBreakMinutes;
    })
    return amt;
  }

  setOvertimeAmount(d: IPayrollDayData): number {
    var amt: number = 0;
    d.payrollDaysData.forEach(t => {
      amt += t.totals.overtimeMinutes;
    })
    return amt;
  }

  setDoubleTimeAmount(d: IPayrollDayData): number {
    var amt: number = 0;
    d.payrollDaysData.forEach(t => {
      amt += t.totals.doubleTimeMinutes;
    })
    return amt;
  }

  setTotalAmount(d: IPayrollDayData): number {
    var amt: number = 0;
    d.payrollDaysData.forEach(t => {
      amt += t.totals.totalDayMinutes;
    })
    return amt;
  }

  setGratuityAmount(d: IPayrollDayData): number {
    var amt: number = 0;
    d.payrollDaysData.forEach(t => {
      amt += t.totals.gratuity;
    })
    return amt;
  }

  setMiscExpensesAmount(d: IPayrollDayData): number {
    var amt: number = 0;
    (d?.payrollDaysData ?? []).forEach(t => {
      amt += t.totals.miscExpenses;
    });
    return amt;
  }

  setCardHeaderColor(d: IPayrollDisplay): string {
    if (d.totalDayMinutes > (d.numberOfWorkingDays * 720))
      return 'danger';
    //else if (d.totalDayMinutes > (d.numberOfWorkingDays * 600))
    // return 'warning';
    return 'info';
  }

  filteradjustments(adj: IAdjustmentData[]): IAdjustmentData[] {
    return adj.filter(a => a.code != 'break-start-time-1' && a.code != 'break-start-time-2' && a.code != 'break-end-time-1' && a.code != 'break-end-time-2');
  }

  setAdjustmentsTitle(d: IAdjustmentData): string {
    if (d.code == 'other-minutes' && d.stringValue?.length > 0) {
      return d.intValue < 0 ? `${d.stringValue} (-)` : d.stringValue;
    }
    const amr = this.payrollService.findAdditionalMinutesReason(d.code);
    if (amr.length) {
      return d.intValue < 0 ? `${amr} (-)` : amr;
    }

    if (d.code == 'other-charge' && d.stringValue?.length > 0) {
      return d.stringValue;
    }
    const acr = this.payrollService.findAdditionalChargeReason(d.code);
    if (acr.length)
      return acr;

    switch (d.code) {
      case 'gratuity': return 'Gratuity';
      case 'toll': return 'Tolls';
      case 'parking': return 'Parking';
    }

    return d.code;
  }

  getAdjDescription(code: string): string {
    return this.payrollService.getAdjustmentsDescription(code);
  }

  setAdjustmentsMinutes(d: IAdjustmentData): string {
    const amr = this.payrollService.findAdditionalMinutesReason(d.code);
    if (amr.length)
      return this.payrollService.minutesToTime(d.intValue);
    return '';
  }

  setAdjustmentsAmount(d: IAdjustmentData): string {
    const acr = this.payrollService.findAdditionalChargeReason(d.code);
    if (acr.length)
      return d.decimalValue.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    return ''
  }

  showActionErrorMessage(msg: string) {
    this.vmi.actionErrorMessage = msg;
    setTimeout(() => {
      this.vmi.actionErrorMessage = undefined;
    }, 2500);
  }

  showActionMessage(msg: string) {
    this.vmi.actionMessage = msg;
    setTimeout(() => {
      this.vmi.actionMessage = undefined;
    }, 1000);
  }

  buildDriverPayrollHeader(pd: IPayrollDayData): string {
    return formatDate(pd.payrollPeriodStartDateTime, 'MM/dd/yyyy', 'en-US') + ' - ' + formatDate(pd.payrollPeriodEndtDateTime, 'MM/dd/yyyy', 'en-US');
    //+ ' for ' + pd.header.driverNumber + ' - ' + pd.header.driverName;
  }

  actionInvoke(a: IActionModel, vmd: IDriverPayrollViewModel) {
    switch (a.code) {
      case 'audit-mode':
        this.vmd$ = this.getDriverPayrollForDisplay$(this.vmi.currentPayrollPeriod.payrollPeriodId,
          vmd.driverPayrollDataFilteredVm.header.payrollPeriodDriverId, a.keyInt);
        break;
      case 'audit-mode-off':
        this.vmd$ = this.getDriverPayrollForDisplay$(this.vmi.currentPayrollPeriod.payrollPeriodId, vmd.driverPayrollDataFilteredVm.header.payrollPeriodDriverId, 0);
        break;
    }
  }

  isDateTimeAreTheSame(date1: Date, date2: Date) {
    if (date1 === date2)
      return true;
    return false;
  }

  isMinutesTimeAreTheSame(min1: number, min2: number) {
    if (min1 === min2)
      return true;
    return false;
  }

  IsCalculated(calcMin: number, min1: number, min2: number): string {
    if (min1 !== min2)
      return ' (Calc)';
    return '      ';
  }
}

/**
 * 
 */
interface IPayrollPageViewModel {
  data?: { payrollPeriods?: IPayrollPeriod[], payrollData?: IPayrollDayData[], statementData: IStatementData };

  payrollPeriodsVm?: IPayrollPeriod[];
  payrollDataVm?: IPayrollDayData[];

  statementDataVm?: IStatementData;

  workingText?: string;
  errorText?: string;
  isValid?: boolean;
}


/**
 * 
 */
interface IPayrollViewModel {
  data?: { payrollDisplayData?: IPayrollDisplay[] };

  payrollDisplayDataVm?: IPayrollDisplay[];
  payrollDisplayDataFilteredVm?: IPayrollDisplay[];

  workingText?: string;
  errorText?: string;
  isValid?: boolean;
}

/**
 * 
 */
interface IDriverPayrollViewModel {
  data?: { driverPayrollData: IPayrollDayData, driverPayrollCompareData?: IPayrollComparison[] };

  driverPayrollDataVm?: IPayrollDayData;
  driverPayrollDataFilteredVm?: IPayrollDayData;
  driverPayrollCompareDataVm?: IPayrollCompareCardViewModel;

  workingText?: string;
  errorText?: string;
  isValid?: boolean;
}

/**
 * 
 */
interface IPayrollPageInfoViewModel {
  payrollDate?: Date;
  recalculatePayroll?: boolean;
  lockPayrollPeriod?: boolean;
  includeTimeSheetPage?: boolean;
  sortByDriverName?: boolean;
  currentPayrollPeriod?: IPayrollPeriod;
  showTimeSheetCheckbox?: boolean;
  confirmationType: number;
  adjustmentsCommited: boolean;
  messageString: string;
  showDriverEmailButton?: boolean;
  statementAvailable?: boolean;
  driverEmails?: string;
  warningCount?: number;
  notSignedTimeSheetsCount?: number;
  timeSheetsIssueCount?: number;
  isReviewCompleted?: boolean;
  isReviewNotCompletedCount?: number;

  reservationFormVm?: IReservationEntryFormViewModel;
  dayFormVm?: IDayEntryFormViewModel;
  totalFormVm?: ITotalEntryFormViewModel;
  lockFormVm?: ILockEntryFormViewModel;
  emailFormVm?: IEmailEntryFormViewModel;
  calcFormVm?: ICalcEntryFormViewModel;

  progressFormVm?: IProgressFormViewModel;

  workingText?: string;
  errorText?: string;
  actionErrorMessage: string;
  actionMessage: string;
}

/**
 * 
 */
interface IReservationEntryFormViewModel {
  data: IReservationEntryFormData;

  okCancelVm?: IFormOkCancelViewModel;

  confirmationNumberVm: IFormInputViewModel;
  gratuityAmountVm: IFormInputViewModel;
  parkingAmountVm: IFormInputViewModel;
  tollAmountVm: IFormInputViewModel;

  miscAmountVm1: IFormInputViewModel;
  miscReasonVm1: IFormSelectViewModel;
  otherReasonVm1: IFormInputViewModel;
  miscAmountVm2: IFormInputViewModel;
  miscReasonVm2: IFormSelectViewModel;
  otherReasonVm2: IFormInputViewModel;
  miscAmountVm3: IFormInputViewModel;
  miscReasonVm3: IFormSelectViewModel;
  otherReasonVm3: IFormInputViewModel;

  showOtherReason1: boolean;
  showOtherReason2: boolean;
  showOtherReason3: boolean;

  dateTimeToMove?: Date;
  allowMoveTrip: boolean;
  moveDateChecked: boolean
  isValid: boolean;
}

/**
 * 
 */
interface IReservationEntryFormData {
  payrollPeriodId: number;
  payrollPeriodDriverDayId: number;
  payrollPeriodDriverId: number;
  segmentRowId: number;
  confirmationNumber: string;
  gratuityAmount: string;
  tollAmount: string;
  parkingAmount: string;

  miscAmount1: string;
  miscReason1: string;
  otherReason1: string;
  miscAmount2: string;
  miscReason2: string;
  otherReason2: string;
  miscAmount3: string;
  miscReason3: string;
  otherReason3: string;

  dateTimeToMove?: Date;
}

/**
 * 
 */
interface IDayEntryFormViewModel {
  data: IDayEntryFormData;

  isValid: boolean;

  okCancelVm?: IFormOkCancelViewModel;

  driverNumberVm: IFormInputViewModel;
  payrollDateVm: IFormInputViewModel;

  additionalMinutesVm1: IFormInputViewModel;
  additionalMinutesReasonVm1: IFormSelectViewModel;
  otherMinReasonVm1: IFormInputViewModel;

  additionalMinutesVm2: IFormInputViewModel;
  additionalMinutesReasonVm2: IFormSelectViewModel;
  otherMinReasonVm2: IFormInputViewModel;

  additionalMinutesVm3: IFormInputViewModel;
  additionalMinutesReasonVm3: IFormSelectViewModel;
  otherMinReasonVm3: IFormInputViewModel;

  miscAmountVm1: IFormInputViewModel;
  miscReasonVm1: IFormSelectViewModel;
  otherReasonVm1: IFormInputViewModel;

  miscAmountVm2: IFormInputViewModel;
  miscReasonVm2: IFormSelectViewModel;
  otherReasonVm2: IFormInputViewModel;

  miscAmountVm3: IFormInputViewModel;
  miscReasonVm3: IFormSelectViewModel;
  otherReasonVm3: IFormInputViewModel;

  breakDateInputVm1: IFormInputViewModel;
  breakStartInputVm1: IFormInputViewModel;
  breakEndInputVm1: IFormInputViewModel;

  breakDateInputVm2: IFormInputViewModel;
  breakStartInputVm2: IFormInputViewModel;
  breakEndInputVm2: IFormInputViewModel;

  showMinOtherReason1: boolean;
  showMinOtherReason2: boolean;
  showMinOtherReason3: boolean;

  showOtherReason1: boolean;
  showOtherReason2: boolean;
  showOtherReason3: boolean;
}

/**
 * 
 */
interface ITotalEntryFormViewModel {
  data: ITotalEntryFormData;

  isValid: boolean;

  okCancelVm?: IFormOkCancelViewModel;

  driverNumberVm: IFormInputViewModel;

  miscAmountVm1: IFormInputViewModel;
  miscReasonVm1: IFormSelectViewModel;
  otherReasonVm1: IFormInputViewModel;

  miscAmountVm2: IFormInputViewModel;
  miscReasonVm2: IFormSelectViewModel;
  otherReasonVm2: IFormInputViewModel;

  miscAmountVm3: IFormInputViewModel;
  miscReasonVm3: IFormSelectViewModel;
  otherReasonVm3: IFormInputViewModel;

  showOtherReason1: boolean;
  showOtherReason2: boolean;
  showOtherReason3: boolean;
}

/**
 * 
 */
interface ILockEntryFormViewModel {
  okCancelVm?: IFormOkCancelViewModel;
}

/**
 * 
 */
interface IEmailEntryFormViewModel {
  data: IEmailEntryFormData;

  viewType: string;
  emailAddressVm1: IFormInputViewModel;
  emailAddressVm2: IFormInputViewModel;
  okCancelVm?: IFormOkCancelViewModel;

  isValid: boolean;
}

/**
 * 
 */
interface ICalcEntryFormViewModel {
  data: ICalcEntryFormData;

  okCancelVm?: IFormOkCancelViewModel;

  emailAddressVm: IFormInputViewModel;

  isValid: boolean;
}

/**
 * 
 */
interface IProgressFormViewModel {
  message?: string;
  valueNow?: number;
  errorText?: string;
  dataList?: { column1: string, column2: string }[];
}

/**
 * 
 */
interface IDayEntryFormData {
  payrollPeriodId: number;
  payrollPeriodDriverDayId: number;
  payrollPeriodDriverId: number;
  driverNumber: string;
  payrollDate: string;

  additionalMinutes1: string;
  additionalMinutesReason1: string;
  additionalMinutesOtherReason1: string;

  additionalMinutes2: string;
  additionalMinutesReason2: string;
  additionalMinutesOtherReason2: string;

  additionalMinutes3: string;
  additionalMinutesReason3: string;
  additionalMinutesOtherReason3: string;

  miscAmount1: string;
  miscReason1: string;
  otherReason1: string;

  miscAmount2: string;
  miscReason2: string;
  otherReason2: string;

  miscAmount3: string;
  miscReason3: string;
  otherReason3: string;

  breakDate1: string;
  breakDate2: string;
  breakStartTime1: string;
  breakStartTime2: string;
  breakEndTime1: string;
  breakEndTime2: string;
}

/**
 * 
 */
interface ITotalEntryFormData {
  payrollPeriodId: number;
  payrollPeriodDriverId: number;
  driverNumber: string;

  miscAmount1: string;
  miscReason1: string;
  otherReason1: string;

  miscAmount2: string;
  miscReason2: string;
  otherReason2: string;

  miscAmount3: string;
  miscReason3: string;
  otherReason3: string;
}

/**
 * 
 */
interface ICalcEntryFormData {
  emailAddress: string;
}

/**
 * 
 */
interface IEmailEntryFormData {
  emailAddress1: string;
  emailAddress2: string;
}


